/** SPA-history entry module — Phase AC.9.
 *
 * Layer: `orchestrator` per docs/design/spa-account-extraction-260524.md §3.7.
 *
 * This is the `<script type="module" src="/static/spa-history/init.js">` target
 * for `web/static/history.html`. Replaces the inline `<script>` block
 * (history.html lines 184-433) with a single ES-module bootstrap.
 *
 * No exports — this module is the history.html entry point.
 * Nothing imports from it.
 */
import { HistoryController } from './controller.js';
import { getAuthFetch } from '../spa-shared/auth-surface.js';
// ─── Window globals ────────────────────────────────────────────────────────────
//
// WHY type assertion: `adaEsc` is injected by a sibling script tag in
// history.html (esc.js); TypeScript cannot see it at compile time.
//
// The Supabase auth surface is NO LONGER read here — it goes through the
// canonical `../spa-shared/auth-surface.js` seam (getAuthFetch). This bundle
// previously read the retired flat global `window.AdaSupabase` (undefined post
// window-adatool-ns migration 4899f24b63), which broke the Bearer header → 401 →
// signed-out History. Epic cross-spa-auth-propagation-260705 Phase 2.
const _win = window;
const esc = _win.adaEsc ?? ((s) => String(s));
// Canonical Bearer-attaching authFetch (fails LOUD, not silent, if the shared
// surface is somehow absent — see auth-surface.ts).
const authFetch = getAuthFetch();
// ─── Construct controller + bootstrap ─────────────────────────────────────────
const controller = new HistoryController({ esc, authFetch });
controller.attach();
void controller.loadHistory();
// ─── Build footer ─────────────────────────────────────────────────────────────
fetch('/api/version')
    .then(r => r.json())
    .then((d) => {
    const el = document.getElementById('app-last-updated');
    if (el && d.build_time) {
        try {
            const f = new Date(d.build_time).toLocaleString('en-US', {
                month: 'long', day: 'numeric', year: 'numeric',
                hour: 'numeric', minute: '2-digit', hour12: true,
            });
            el.textContent = 'Built ' + f;
        }
        catch (_e) { /* ignore */ }
    }
    else if (el) {
        el.textContent = 'v' + (d.version ?? '');
    }
})
    .catch(() => { });
